import { TypographyBase } from "@/components/typography/Base";
import { TypographyMuted } from "@/components/typography/Muted";
import { Link } from "@tanstack/react-router";
import { format } from "date-fns";
import { ArrowRight, Building } from "lucide-react";
import { OrganizationInvitation } from "../types/organizationInvitations.type";

interface Props {
  invitation: OrganizationInvitation;
}

export function OrganizationInvitationsListItem({
  invitation: { id, invitedAt, organizationName }
}: Props) {
  return (
    <Link
      to="/invitation/$invitationId"
      params={{ invitationId: id }}
      search={{ redirect: { to: "/invitations" } }}
    >
      <button className="w-full grid grid-cols-[3fr_1fr_25px] items-center p-2 border-b transition-colors hover:bg-muted/50">
        <div className="flex items-center gap-2">
          <Building size={16} />
          <TypographyBase>{organizationName}</TypographyBase>
        </div>
        <TypographyMuted>{format(invitedAt, "PP")}</TypographyMuted>
        <ArrowRight size={16} />
      </button>
    </Link>
  );
}
